import { FileText } from "lucide-react";

type ContextCompactionDividerProps = {
  active?: boolean;
};

const ContextCompactionDivider = ({ active = false }: ContextCompactionDividerProps) => (
  <div
    className="my-6 flex w-full items-center gap-2 px-1 sm:gap-3"
    role={active ? "status" : "separator"}
    aria-live={active ? "polite" : undefined}
    aria-label={active ? "Automatically compacting context" : "Context automatically compacted"}
  >
    <span aria-hidden="true" className="h-px min-w-3 flex-1 bg-base-content/15" />
    {active ? (
      <span className="trace-shimmer whitespace-nowrap text-[13px] font-medium">
        Automatically compacting context
      </span>
    ) : (
      <span className="flex shrink-0 items-center gap-1.5 text-[13px] font-medium text-base-content/60">
        <FileText aria-hidden="true" size={16} strokeWidth={1.8} />
        Context automatically compacted
      </span>
    )}
    <span aria-hidden="true" className="h-px min-w-3 flex-1 bg-base-content/15" />
  </div>
);

export default ContextCompactionDivider;
